// extracted by mini-css-extract-plugin
export default {"cancelTicket":"horizontalList_cancelTicket__k1fkL","question":"horizontalList_question__HqtlE","ans":"horizontalList_ans__3hClf","wrapper":"horizontalList_wrapper__cjvFR"};